// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Cloud Costs API
 * API to get cloud cost information about Aura components and dev environments. Is used by the Aura Portal.
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApitypesEnvironmentCosts } from './ApitypesEnvironmentCosts';
import {
  ApitypesEnvironmentCostsFromJSON,
  ApitypesEnvironmentCostsFromJSONTyped,
  ApitypesEnvironmentCostsToJSON,
  ApitypesEnvironmentCostsToJSONTyped,
} from './ApitypesEnvironmentCosts';

/**
 *
 * @export
 * @interface ApitypesEnvironmentsCostsResponse
 */
export interface ApitypesEnvironmentsCostsResponse {
  /**
   * Format: 2026-12-31
   * @type {string}
   * @memberof ApitypesEnvironmentsCostsResponse
   */
  endDate?: string;
  /**
   *
   * @type {Array<ApitypesEnvironmentCosts>}
   * @memberof ApitypesEnvironmentsCostsResponse
   */
  environments?: Array<ApitypesEnvironmentCosts>;
  /**
   * Format: 2026-12-31
   * @type {string}
   * @memberof ApitypesEnvironmentsCostsResponse
   */
  startDate?: string;
  /**
   *
   * @type {number}
   * @memberof ApitypesEnvironmentsCostsResponse
   */
  totalEnvironments?: number;
}

/**
 * Check if a given object implements the ApitypesEnvironmentsCostsResponse interface.
 */
export function instanceOfApitypesEnvironmentsCostsResponse(
  value: object,
): value is ApitypesEnvironmentsCostsResponse {
  return true;
}

export function ApitypesEnvironmentsCostsResponseFromJSON(
  json: any,
): ApitypesEnvironmentsCostsResponse {
  return ApitypesEnvironmentsCostsResponseFromJSONTyped(json, false);
}

export function ApitypesEnvironmentsCostsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApitypesEnvironmentsCostsResponse {
  if (json == null) {
    return json;
  }
  return {
    endDate: json['endDate'] == null ? undefined : json['endDate'],
    environments:
      json['environments'] == null
        ? undefined
        : (json['environments'] as Array<any>).map(
            ApitypesEnvironmentCostsFromJSON,
          ),
    startDate: json['startDate'] == null ? undefined : json['startDate'],
    totalEnvironments:
      json['totalEnvironments'] == null ? undefined : json['totalEnvironments'],
  };
}

export function ApitypesEnvironmentsCostsResponseToJSON(
  json: any,
): ApitypesEnvironmentsCostsResponse {
  return ApitypesEnvironmentsCostsResponseToJSONTyped(json, false);
}

export function ApitypesEnvironmentsCostsResponseToJSONTyped(
  value?: ApitypesEnvironmentsCostsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endDate: value['endDate'],
    environments:
      value['environments'] == null
        ? undefined
        : (value['environments'] as Array<any>).map(
            ApitypesEnvironmentCostsToJSON,
          ),
    startDate: value['startDate'],
    totalEnvironments: value['totalEnvironments'],
  };
}
